/**
 * Derive a trip's payment status from its invoices.
 * Returns one of: 'paid' | 'pending' | 'overdue' | null (no invoices yet).
 *
 * Matching: invoice.tripId === trip.tripId OR invoice.displayTripId ===
 * trip.displayTripId. Cancelled/converted invoices are ignored.
 */
export const tripPaymentStatus = (trip, invoices = []) => {
  if (!trip) return null;
  const matched = invoices.filter((inv) => {
    const st = (inv.status || '').toLowerCase();
    if (st === 'cancelled' || st === 'converted') return false;
    return (
      (trip.tripId && inv.tripId === trip.tripId) ||
      (trip.displayTripId && inv.displayTripId === trip.displayTripId)
    );
  });
  if (matched.length === 0) return null;

  let total = 0;
  let paid = 0;
  let overdue = false;
  const todayIso = new Date().toISOString().slice(0, 10);
  for (const inv of matched) {
    const t = Number(inv.totalAmount || 0);
    const p = Number(inv.amountPaid || 0);
    total += t;
    paid += p;
    const due = (inv.dueDate || '').slice(0, 10);
    const settled = (inv.paymentStatus || '').toLowerCase() === 'paid' || p >= t;
    if (!settled && due && due < todayIso) overdue = true;
  }
  if (total > 0 && paid >= total) return 'paid';
  if (overdue) return 'overdue';
  return 'pending';
};

export const PAYMENT_BADGE = {
  paid: { label: 'Paid', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  pending: { label: 'Pending', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  overdue: { label: 'Overdue', cls: 'bg-red-50 text-red-700 border-red-200' },
};
